import { CANONICALLS_CONTINUITY_ANCHOR } from "../../lib/canonicallsCopy";

export function ContinuityAnchor({ subtle }: { subtle?: boolean }) {
  return (
    <p className={`canonicalls-anchor${subtle ? " canonicalls-anchor--subtle" : ""}`}>{CANONICALLS_CONTINUITY_ANCHOR}</p>
  );
}
